<div class="gcontainer report-preview-wrapper">
  <div class="row">
    <div class="col-md-11">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active breadcrumb cursor" aria-current="page">
            <a class="c-primary" [routerLink]="'/dashboard'" tabindex="0"> Dashboard </a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Report - Native Soil
          </li>
        </ol>
      </nav>
    </div>
    <div class="col-md-1">
      <button class="refresh" mat-raised-button (click)="refresh()" >
        Refresh
      </button>
    </div>
  </div>
  <div class="report-header">
    <div class="head">
      <h1>Thermal Resistivity Report</h1>
    </div>
    <div class="banner-wrapper">
      <div class="r-l">
        <span class="st c-primary">{{ statusLabel }}</span>
      </div>
      @if (!userService.roleCheck(['Accounting'])) {
        <div class="r-r">
          <app-customer-attachments
            [projectId]="projectId"
            [backgroundClass]="'yellow'"
            [showSuccess]="false"
          style="vertical-align: middle; margin-right: 16px"></app-customer-attachments>
          <button class="c-primary" (click)="openViewSubmissionForm()">
            <img src="assets/icons/File.svg" alt="" />View Submission Form
          </button>
          <button class="c-primary" (click)="openWorksheet()">
            <img src="assets/icons/File.svg" alt="" />View Worksheet
          </button>
          <button class="c-primary" (click)="openNotesDialog()">
            <img src="assets/icons/Comment.svg" alt="" />View Notes
          </button>
          <button class="c-primary" (click)="printCover()">
            <img src="assets/icons/print-gray.svg" alt="" />Print Cover
          </button>
          <button class="c-primary" (click)="openAssignToDialog()">
            <img src="assets/icons/people.svg" alt="" />Assign
          </button>
          <button class="c-primary" (click)="openSetStatusDialog()">
            <img src="assets/icons/Done.svg" alt="" />Set Status
          </button>
        </div>
      }
      <div class="clearfix">
        <mat-divider></mat-divider>
        <div class="assignto"><span >Assigned To: {{ reportOwner }}</span></div>

        <div class="reviewby"> <span>Review By: {{ firstReviewerName }}
          @if (secondReviewerName) {
            <span>, {{ secondReviewerName }}</span>
          }
        </span></div>
      </div>
    </div>
    <div
      class="r-tab-wrapper">
      <mat-tab-group
        #tabGroup
        animationDuration="0"
        [(selectedIndex)]="selectedIndex">
        @if (!userService.roleCheck(['Accounting'])) {
          <mat-tab label="EDIT">
            <app-edit-native-soil-report
              [projectId]="projectId"
            [fieldtesting]="worksheetRecords?.project?.geothermField ?? false"></app-edit-native-soil-report>
          </mat-tab>
        }
      </mat-tab-group>

    </div>
  </div>
</div>
